import { render } from "./CreateNewPromiseForm.vue?vue&type=template&id=8c6c4094"
import script from "./CreateNewPromiseForm.vue?vue&type=script&lang=js"
export * from "./CreateNewPromiseForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__